import { Content } from "@radix-ui/react-alert-dialog";

import React from "react";

import { cn } from "@/lib/utils";

type AlertContentProps = {
  children: React.ReactNode;
  className?: string;
};

const AlertContent = React.forwardRef<HTMLDivElement, AlertContentProps>(
  (props, forwardedRef) => {
    const { children, className, ...rest } = props;
    return (
      <Content
        {...rest}
        ref={forwardedRef}
        className={cn(
          "z-50 bg-white rounded-md shadow-lg fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-11/12 max-w-md max-h-[85vh] p-4",
          className,
        )}
      >
        {children}
      </Content>
    );
  },
);

AlertContent.displayName = "AlertContent";

export { AlertContent };
